/*
 * File: /src/store/modules/team.js
 * Created Date: Friday April 26th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 26th April 2019 9:32:57 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import teamService from 'src/services/teamServices.js';

const state = {
  team: undefined,
};

const getters = {
  getTeam: state => state.team,
  getUserById: state => id => {
    return state.team.find(t => {
      if (+t.id === +id) {
        return t;
      }
    });
  }
};
const actions = {
  fetchTeam: ({ commit, rootGetters }, companyId) => {
    if (state.team == undefined) {
      return teamService
        .fetchTeam()
        .then(r => {
          commit('setTeam', r.data);
          return r.data;
        });
    }
  },
  unloadTeam({ commit }) {
    commit('setTeam', undefined);
  },
};
const mutations = {
  setTeam(state, team) {
    state.team = Object.assign([], team);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
